import React, { useState, useEffect } from "react";
import { Dropdown, Modal, Button, Form, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  addContent,
  getContents,
  updateContent,
  deleteContent,
} from "../../../FIREBASECONFIG"; 
import image from "../../../images/log.png";
const BookingCities = () => {
  const collectionName = "cities";
  const folderName = "slider_image";

  const [cities, setCities] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 15;

  // Separate loading states
  const [loadingData, setLoadingData] = useState(false);
  const [saving, setSaving] = useState(false);

  // Modal State
  const [showModal, setShowModal] = useState(false);
  const [editCity, setEditCity] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  // Fetch data
  useEffect(() => {
    const fetchCities = async () => {
      setLoadingData(true);
      try {
        const data = await getContents(collectionName);
        setCities(data);
      } catch (err) {
        console.error("Error fetching cities:", err);
      }
      setLoadingData(false);
    };
    fetchCities();
  }, []);

  // Filtered Data
  const filteredCities = cities.filter((c) => {
    const lower = searchTerm.toLowerCase();
    return (
      c.name.toLowerCase().includes(lower) ||
      c.description.toLowerCase().includes(lower)
    );
  });
  /**  Paginated Data  */ 
  const totalPages = Math.ceil(filteredCities.length / itemsPerPage);
  const paginatedCities = filteredCities.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  // Handle Save (Add/Edit)
  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    const form = e.target;
    const file = form.image.files[0];

    const cityData = {
      name: form.cityName.value,
      description: form.description.value,
      alt: form.alt.value,
      image: editCity?.image || "", // keep old if no new image
    };

    try {
      if (editCity) {
        const updated = await updateContent(
          collectionName,
          folderName,
          editCity.id,
          cityData,
          file
        );
        setCities((prev) =>
          prev.map((c) => (c.id === editCity.id ? updated : c))
        );
      } else {
        const added = await addContent(collectionName, folderName, cityData, file);
        setCities((prev) => [...prev, added]);
      }
      setShowModal(false);
      setEditCity(null);
      setPreviewImage(null);
    } catch (err) {
      console.error("Error saving city:", err);
    }
    setSaving(false);
  };
  // Handle Delete
  const handleDelete = async (id) => {
    // if (!window.confirm("Are you sure you want to delete this city?")) return;
    setSaving(true);
    try {
      await deleteContent(collectionName, id);
      setCities((prev) => prev.filter((c) => c.id !== id));
    } catch (err) {
      console.error("Error deleting city:", err);
    }
    setSaving(false);
  };

  // Handle File Change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setPreviewImage(url);
    }
  };

  return (
    <div className="col-12">
      <div className="card">
        {/* Header */}
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title m-0">Cities</h4>
          <div className="d-flex align-items-center gap-2">
            <input
              type="text"
              className="form-control"
              placeholder="Search city"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(0);
              }}
            />
            <button
              className="btn btn-secondary btn-md"
              style={{ whiteSpace: "nowrap" }}
              onClick={() => {
                setEditCity(null);
                setPreviewImage(null);
                setShowModal(true);
              }}
              disabled={saving}
            >
             Add City
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="card-body">
          {loadingData && cities.length === 0 ? (
            <div className="text-center py-4">
             <Spinner animation="border" />
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped align-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Image</th>
                    <th>City Name</th>
                    <th>Description</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedCities.length > 0 ? (
                    paginatedCities.map((item, i) => (
                      <tr key={item.id}>
                        <td>{currentPage * itemsPerPage + i + 1}</td>
                        <td>
                          <img
                            src={item.image}
                            alt={item.alt}
                            style={{ width: "60px",height: "40px",  borderRadius: "6px" }}
                          />
                        </td>
                        <td>{item.name}</td>
                        <td style={{ maxWidth: "250px",whitespace:"nowrap",overflow:"hidden",textOverflow:"ellipsis" }}>
                          {item.description}
                        </td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle variant="link">
                              &#x2022;&#x2022;&#x2022;
                            </Dropdown.Toggle>
                            <Dropdown.Menu align="end">
                              <Dropdown.Item
                                onClick={() => {
                                  setEditCity(item);
                                  setPreviewImage(item.image);
                                  setShowModal(true);
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => handleDelete(item.id)}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No cities found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination */}
          {cities.length > 0 && (
           <div className="d-flex justify-content-between align-items-center mt-3">
           <div>
             Showing{" "}
             {filteredCities.length === 0
               ? 0
               : currentPage * itemsPerPage + 1}{" "}
             to{" "}
             {Math.min(
               (currentPage + 1) * itemsPerPage,
               filteredCities.length
             )}{" "}
             of {filteredCities.length} entries
           </div>
         
           <div>
             <button
               className={`btn btn-sm btn-outline-primary me-2 ${
                 currentPage === 0 ? "disabled" : ""
               }`}
               onClick={() =>
                 currentPage > 0 && setCurrentPage(currentPage - 1)
               }
             >
               Prev
             </button>
         
             {Array.from({ length: totalPages }, (_, i) => (
               <button
                 key={i}
                 className={`btn btn-sm border ${
                   currentPage === i ? "btn-primary text-white" : ""
                 }`}
                 onClick={() => setCurrentPage(i)}
               >
                 {i + 1}
               </button>
             ))}
         
             <button
               className={`btn btn-sm btn-outline-primary ms-2 ${
                 currentPage === totalPages - 1 ? "disabled" : ""
               }`}
               onClick={() =>
                 currentPage + 1 < totalPages && setCurrentPage(currentPage + 1)
               }
             >
               Next
             </button>
           </div>
         </div>         
          )}
        </div>
      </div>

      {/* Add/Edit Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Form onSubmit={handleSave}>
          <Modal.Header closeButton>
            <Modal.Title>
              {editCity ? "Edit City" : "Add City"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <Form.Control
                name="cityName"
                defaultValue={editCity?.name || ""}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="description"
                defaultValue={editCity?.description || ""}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Alt Text</Form.Label>
              <Form.Control
                name="alt"
                defaultValue={editCity?.alt || ""}
                placeholder="Image alt text"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Image</Form.Label>
              <Form.Control
                type="file"
                name="image"
                accept="image/*"
                onChange={handleFileChange}
              />
              {(previewImage || editCity?.image) && (
                <div className="mt-2">
                  <img
                    src={previewImage || editCity?.image}
                    alt="Preview"
                    style={{ width: "120px", borderRadius: "8px" }}
                  />
                </div>
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button type="submit" variant="primary" disabled={saving}>
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};
export default BookingCities;